import { useEffect, useState } from "react";

const InputForm = ({
  id,
  placeHolder,
  value,
  handleInputChange,
  error,
}: any) => {
  const [localValue, setLocalValue] = useState(value);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);
  return (
    <div>
    <input
      type="text"
      value={localValue}
      onChange={(e) => {
        setLocalValue(e.target.value);
        handleInputChange(id, e.target.value);
        if (e.target.value.trim() !== "") {
          setTimeout(() => {
            setShowError(true);
          }, 500)
        }
      }}
      placeholder={placeHolder}
      style={{ borderColor: showError && error ? "red" : "#ccc" }}
    />
    {showError && error && (
      <p style={{ color: "red", fontSize: "12px", marginTop: "10px" }}>
        {error}
      </p>
    )}
  </div>
  );
};

export default InputForm;
